import styled, { css } from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';
import { heroTitle } from '@stylesheets/helpers';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 780px;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level6};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      gap: ${spacing.level5};
    `}
  }
`;

export const HeroIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme: { colors } }) => css`
    color: ${colors.primary};
  `}
`;

export const Title = styled.h1`
  text-align: center;
  overflow-wrap: anywhere;
  color: ${({ theme: { colors } }) => colors.onBackground};
  ${heroTitle}
`;

export const InputOuterWrapper = styled.div`
  width: 100%;

  ${({ theme: { spacing, borderRadius } }) => css`
    border-radius: ${borderRadius.large};
    padding: ${spacing.level4} ${spacing.level5} ${spacing.level5};

    @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
      padding-inline: 0;
    }
  `}
`;

export const ChipsSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level4};
  `}
`;

export const ChipsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;

export const PromptChip = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
  white-space: nowrap;

  ${({ theme: { colors, font, borderRadius } }) => css`
    padding: 0.625rem 1.25rem;
    border-radius: ${borderRadius.large};
    background-color: ${colors.surfaceContainerHigh};
    color: ${colors.onSurfaceVariant};
    font-size: ${font.labelLarge.fontSize};
    font-weight: 500;

    &:hover {
      background-color: ${colors.surfaceContainerHighest};
    }
  `}
`;
